import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import { formatDate } from '../../../utils';
import { formatPostDate } from './utils';

import MoreActionsButton from '../../Button/MoreActionsButton';
import DropDownMenu from '../../DropDownMenu';
import CellPersonWithImage from '../../Table/CellPersonWithImage';

export const PostHeader = ({
  creator,
  creatorInfo,
  dropDownActions,
  createdAt,
}) => (
  <Box display="flex" justifyContent="space-between">
    {creator && (
      <CellPersonWithImage
        person={creator}
        personInfo={creatorInfo}
        linkUrl={`/global-person-search/${creator?.id}`}
        personCustomStyle={{ fontWeight: 'bold' }}
      />
    )}
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      {dropDownActions.length > 0 && (
        <DropDownMenu
          items={dropDownActions}
          title=""
          CustomAnchor={({ onClick }) => (
            <MoreActionsButton onClick={onClick} />
          )}
        />
      )}
      <Tooltip
        className="post-header-tooltip"
        title={formatDate(createdAt)}
        placement="top"
        arrow
      >
        <Box
          sx={
            dropDownActions.length > 0
              ? { marginTop: '0.5rem' }
              : { alignSelf: 'flex-start' }
          }
        >
          {formatPostDate(createdAt)}
        </Box>
      </Tooltip>
    </Box>
  </Box>
);

PostHeader.propTypes = {
  creator: PropTypes.instanceOf(Object),
  creatorInfo: PropTypes.string,
  dropDownActions: PropTypes.instanceOf(Array),
  createdAt: PropTypes.string.isRequired,
};
